'use client';

import { useState, useEffect } from 'react';
import styles from './CookieConsent.module.css';
import Tabs from "../Tabs/Tabs";
import { useCookieConsent } from '@/hooks/useCookieConsent';

function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
}

function CookieConsent(){
  const [isOpen, setIsOpen] = useState(false);
  const [openCategories, setOpenCategories] = useState<{[key:string]: boolean}>({});
  const [tabsActive, setTabsActive] = useState(false);
  const { consent, updateConsent } = useCookieConsent();

  const toggleTabs = () => {
    setTabsActive(prev => !prev);
    setIsOpen(false);
  };

  useEffect(() => {
          if (typeof window !== 'undefined') {
              const storedConsent = localStorage.getItem('cookie-preferences');
              if (!storedConsent) {
                  setIsOpen(true);
              }
          }
        }, []);

  const handleOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsOpen(true);
  };

  const handleClose = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsOpen(false);
  };

  const toggleCategory = (key: string) => {
    setOpenCategories(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const tabItems = [
    { label: "Declaração de Cookies", 
      content: 
          <div className={styles.cookiescript_tabs_content}>
            <div className={styles.cookiescript_declarationwrap}>
              <div className={styles.cookiescript_category}>
                <div className={styles.cookiescript_category_main}>
                  <div className={styles.cookiescript_category_info}>
                    <h2 className={styles.title}>Desempenho</h2>
                    <p>Cookies de desempenho mostram como os visitantes interagem com o site e ajudam a melhorar sua usabilidade. Eles coletam dados de forma agregada, sem identificar o usuário.</p>
                  </div>
                  <div className={styles.cookiescript_category_control}>
                    <div className={styles.inputContainer}>
                      <input 
                        onChange={() => {
                          updateConsent({
                            desempenho: !consent?.desempenho,
                            funcionalidades: !!consent?.funcionalidades,
                            necessarios: !!consent?.necessarios
                          })
                        }} 
                        checked={consent?.desempenho} type="checkbox" aria-label='Aceitar Cookies Desempenho'/>
                    </div>
                  </div>
                </div>
                <div className={styles.cookiescript_category_cookies_button} onClick={() => toggleCategory("desempenho")}>
                  {openCategories["desempenho"] ? "Ocultar Cookies" : "Mostrar Cookies"} <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
                </div>
                <div className={`${styles.cookiescript_category_cookies_hidden} ${openCategories["desempenho"] ? styles.active : ""}`}>
                  <ul>
                    <li>_hjSessionUser_605312</li>
                    <li>_hp2_id.236035469</li>
                    <li>_hp2_props.236035469</li>
                  </ul>
                </div>
              </div>

              <div className={styles.cookiescript_category}>
                <div className={styles.cookiescript_category_main}>
                  <div className={styles.cookiescript_category_info}>
                    <h2 className={styles.title}>Estritamente Necessários</h2>
                    <p>Cookies estritamente necessários garantem o funcionamento do site e não podem ser desativados. Eles permitem navegação, acesso a áreas seguras e carregamento correto de recursos.</p>
                  </div>
                  <div className={styles.cookiescript_category_control}>
                    <div className={styles.inputContainer}>
                      <input checked disabled type="checkbox" aria-label='Aceitar Cookies Estritamente Necessários'/>
                    </div>
                  </div>
                </div>
                <div className={styles.cookiescript_category_cookies_button} onClick={() => toggleCategory("necessarios")}>
                  {openCategories["necessarios"] ? "Ocultar Cookies" : "Mostrar Cookies"} <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
                </div>
                <div className={`${styles.cookiescript_category_cookies_hidden} ${openCategories["necessarios"] ? styles.active : ""}`}>
                  <ul>
                    <li>CloudFront-Key-Pair-Id</li>
                    <li>CloudFront-Policy</li>
                    <li>CloudFront-Signature</li>
                    <li>_ga</li>
                    <li>_ga_6KP8TBVYVD</li>
                    <li>_ga_EWMH54J8VG</li>
                    <li>_ga_V6EP3JLPPZ</li>
                    <li>_ga_ZF4SN2HS9X</li>
                    <li>_gid</li>
                  </ul>
                </div>
              </div>

              <div className={styles.cookiescript_category}>
                <div className={styles.cookiescript_category_main}>
                  <div className={styles.cookiescript_category_info}>
                    <h2 className={styles.title}>Funcionalidade</h2>
                    <p>Cookies de funcionalidade guardam preferências e ajustes do usuário, deixando a navegação mais prática e personalizada.</p>
                  </div>
                  <div className={styles.cookiescript_category_control}>
                    <div className={styles.inputContainer}>
                      <input  
                      onChange={() => {
                        updateConsent({
                          desempenho: !!consent?.desempenho,
                          funcionalidades: !consent?.funcionalidades,
                          necessarios: !!consent?.necessarios
                        })
                      }}
                      checked={consent?.funcionalidades} type="checkbox" aria-label='Aceitar Cookies Funcionalidade'/>
                    </div>
                  </div>
                </div>
                <div className={styles.cookiescript_category_cookies_button}  onClick={() => toggleCategory("funcionalidade")}>
                  {openCategories["funcionalidade"] ? "Ocultar Cookies" : "Mostrar Cookies"} <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
                </div>
                <div className={`${styles.cookiescript_category_cookies_hidden} ${openCategories["funcionalidade"] ? styles.active : ""}`}>
                  <ul>
                    <li>hubspot_session</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
    },
    { label: "Sobre Cookies", 
      content: 
          <div className={styles.aboutCookies}>
            <p>Cookies são pequenos arquivos de texto armazenados no dispositivo do usuário quando ele visita um site. Eles permitem melhorar a navegação, viabilizar determinadas funcionalidades e oferecer uma experiência mais eficiente.</p>

            <p>Os cookies estritamente necessários, essenciais para o funcionamento adequado do site, podem ser utilizados sem solicitação de consentimento. Já os demais tipos de cookies só serão ativados mediante a sua autorização.</p>

            <p>O usuário pode, a qualquer momento, alterar ou retirar seu consentimento por meio da nossa Configuração de cookies.</p>

            <p>Além disso, utilizamos cookies para coletar dados que nos ajudam a personalizar conteúdos e avaliar a eficácia de nossas campanhas de publicidade.</p>
          </div> 
    }
  ];

  return (
    <>
      {!isOpen && (
        <div
          className={styles.cookie_badge}
          id='cookiescriptbadge'
          role="button"
          aria-labelledby="cookiescriptbadge-text"
          onClick={handleOpen}
        >
          <div className={styles.cookie_badgeimage}>
            <img
              src="/images/cookies-da-web.png"
              alt="Ícone botão de consentimento"
            />
          </div>
          <div id="cookiescriptbadge-text" className={styles.cookie_badgetext}>Configuração de Cookies</div>
        </div>
      )}

      {isOpen && (
        <div
          id='cookiescript_wrapper'
          tabIndex={0}
          role="dialog" 
          aria-label='Conteúdo sobre consentimento de cookies'
        >
          <div className={styles.cookiescript_content}>
            <div className={styles.cookiescript_pre_header}>
              <div
                className={styles.cookiescript_close}
                id='closecookie'
                tabIndex={0}
                role="button"
                aria-label="Close"
                onClick={handleClose}
              >
                ×
              </div>
            </div>

            <div className={styles.cookiescript_header}>Este website usa cookies</div>

            <div className={styles.cookiescript_description}>
              <span>
                Utilizamos cookies para personalizar conteúdo, anúncios e analisar nosso tráfego. Também compartilhamos informações sobre o uso do nosso site com nossos parceiros de publicidade e análise, que podem combiná-las com outras informações que você forneceu a eles ou que eles coletaram do uso de seus serviços.
              </span>
              <a
                id="cookiescript_readmore"
                target="_blank"
                aria-label="Política de Privacidade, opens a new window"
                href="https://site-hmg.bvirtual.com.br/PoliticaPrivacidade"
              >
                Política de Privacidade
              </a>
            </div>

            <div className={styles.cookiescript_checkboxs}>
              <div className={styles.cookiescript_checkbox}>
                <input onChange={() => {
                  updateConsent({
                    desempenho: !consent?.desempenho,
                    funcionalidades: !!consent?.funcionalidades,
                    necessarios: !!consent?.necessarios
                  })
                }} 
                checked={consent?.desempenho} type="checkbox" id='desempenho' aria-label='Aceite Cookie Desempenho' />
                <label htmlFor='desempenho'>
                  <span className={styles.cookiescript_checkbox_label}>Desempenho</span>
                </label>
              </div>

              <div className={styles.cookiescript_checkbox}>
                <input checked disabled type="checkbox" id='necessario' aria-label='Aceite Cookie Necessário'/>
                <label htmlFor='necessario'>
                  <span className={styles.cookiescript_checkbox_label}>Necessário</span>
                </label>
              </div>

              <div className={styles.cookiescript_checkbox}>
                <input 
                onChange={() => {
                  updateConsent({
                    desempenho: !!consent?.desempenho,
                    funcionalidades: !consent?.funcionalidades,
                    necessarios: !!consent?.necessarios
                  })
                }}
                checked={consent?.funcionalidades} type="checkbox" id='funcionalidade' aria-label='Aceite Cookie Funcionalidade'/>
                <label htmlFor='funcionalidade'>
                  <span className={styles.cookiescript_checkbox_label}>Funcionalidade</span>
                </label>
              </div>
            </div>

            <div className={styles.cookiescript_buttons}>
              <div
                className={styles.cookiescript_reject}
                tabIndex={0}
                role="button"
                onClick={() => {
                  setIsOpen(false);
                  updateConsent({
                    desempenho: false,
                    funcionalidades: false,
                    necessarios: false
                  })
                  window.location.reload();
                }}
                aria-label='Recusar todos os cookies'
              >
                Recusar todos
              </div>
              <div
                className={styles.cookiescript_accept}
                tabIndex={0}
                role="button"
                onClick={() => {
                  setIsOpen(false);
                  updateConsent({
                    desempenho: true,
                    funcionalidades: true,
                    necessarios: true
                  })
                  window.location.reload();
                }}
                aria-label='Aceitar todos os cookies'
              >
                Aceitar todos
              </div>
            </div>

            <div className={styles.cookiescript_manage_wrap} onClick={toggleTabs} tabIndex={0} role="button">
              <div className={styles.cookiescript_manage}>
                <svg role="none" className={styles.cookiescript_manageicon} viewBox="0 0 9.62 9.57">
                  <g id="cs-manage-btn">
                    <g id="cs-manage-btn-1-2">
                      <path className={styles.cookiescript_gear} d="M9.46,6.06l-1.1-.78c0-.16.06-.31.06-.47a1.27,1.27,0,0,0-.06-.47L9.57,3.4l-1.15-2L7,1.93a2.74,2.74,0,0,0-.83-.47L6,0H3.61L3.35,1.46a7.14,7.14,0,0,0-.79.47L1.15,1.36,0,3.4l1.15.94c0,.16,0,.31,0,.47a1.51,1.51,0,0,0,0,.47l-1,.78A.75.75,0,0,0,0,6.17l1.15,2,1.41-.58a2.49,2.49,0,0,0,.84.47l.21,1.47H6a.53.53,0,0,1,0-.21L6.22,8.1a4,4,0,0,0,.84-.47l1.41.58,1.15-2A.75.75,0,0,0,9.46,6.06Zm-4.65.19A1.47,1.47,0,1,1,6.28,4.78,1.47,1.47,0,0,1,4.81,6.25Z"></path>
                    </g>
                  </g>
                </svg>
                <span>
                  Mostrar detalhes      
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className={`${styles.cookiescript_tabs} ${tabsActive ? styles.active : ''}`}>
        <div className={styles.cookiescript_tabs_wrapper}>
          <div className={styles.cookiescript_tabs_header}>
            <div className={styles.cookiescript_close} tabIndex={0} id='closeMoreInfo' role="button" onClick={() => setTabsActive(false)} onKeyDown={(e) => {
    if (e.key === 'Enter' || e.key === ' ') setTabsActive(false);
  }} aria-label="Close">×</div>
          </div>

          <div className={styles.cookiescript_main}>
            <div className={styles.cookiescript_main_info}>
              <h2 className={styles.title}>Este website usa cookies</h2>
              <p>Usamos cookies para deixar sua experiência mais personalizada e entender melhor o tráfego do nosso site. Conheça os cookies que utilizamos e suas funções:</p>
              
            </div>
          </div>

          <div>
            <Tabs tabs={tabItems} />
          </div>

          <div className={styles.cookiescript_tabs_footer}>
            <div className={styles.cookiescript_tabs_buttons}>
              <div onClick={() => {
                updateConsent({
                  desempenho: false,
                  funcionalidades: false,
                  necessarios: false
                })
                setTabsActive(false);
                window.location.reload();
              }} id="cookiescript_reject" className={styles.cookiescriptButtonWhite} tabIndex={0} role="button">
                Recusar todos        
              </div>
              <div 
                onClick={() => {
                  updateConsent({
                    desempenho: true,
                    funcionalidades: true,
                    necessarios: true
                  })
                  setTabsActive(false);
                  window.location.reload();
                }}
                id="cookiescript_accept" className={styles.cookiescriptButtonBlue} tabIndex={0} role="button">
                Aceitar todos        
              </div>              
              {/* <div onClick={() => setTabsActive(false)} id="cookiescript_save" className={styles.cookiescriptButtonBlue} tabIndex={0} role="button">
                Guardar e Fechar        
              </div> */}
            </div> 
          </div>
        </div>
      </div>
    </>
  );
}

export default CookieConsent;